import React, { useState } from 'react'
import { Modal } from 'antd'
import {
  ExclamationCircleFilled,
  CheckCircleFilled,
  CloseCircleFilled,
  InfoCircleFilled
} from '@ant-design/icons'
import './ModalConfirm.scss' // Import file CSS riêng

let showConfirm // Biến để gọi modal từ bất kỳ đâu

const iconMap = {
  info: <InfoCircleFilled className="modal-icon info-icon" />,
  success: <CheckCircleFilled className="modal-icon success-icon" />,
  warning: <ExclamationCircleFilled className="modal-icon warning-icon" />,
  error: (
    <CloseCircleFilled
      className="modal-icon error-icon"
      style={{ color: 'red' }}
    />
  )
}

const ModalConfirm = () => {
  const [loading, setLoading] = useState(false)
  const [modalProps, setModalProps] = useState({
    open: false,
    title: 'Xác nhận',
    content: 'Bạn có chắc chắn muốn thực hiện hành động này?',
    type: 'warning', // Mặc định là cảnh báo
    onOk: () => {},
    onCancel: () => {},
    okText: 'Xác nhận',
    cancelText: 'Đóng'
  })

  showConfirm = ({
    title,
    content,
    type = 'warning', // Các loại: info, success, warning, error
    onOk,
    onCancel,
    okText = 'Xác nhận',
    cancelText = 'Đóng'
  }) => {
    setModalProps({
      open: true,
      title: title || 'Xác nhận',
      content: content || 'Bạn có chắc chắn muốn thực hiện hành động này?',
      type,
      onOk: async () => {
        setLoading(true)

        const error = await onOk?.()

        setLoading(false)

        if (!error) {
          setModalProps((prev) => ({ ...prev, open: false }))
        }
      },
      onCancel: () => {
        onCancel?.()
        setModalProps((prev) => ({ ...prev, open: false }))
      },
      okText,
      cancelText
    })
  }

  return (
    <Modal
      open={modalProps.open}
      title={
        <div className="modal-header">
          {iconMap[modalProps.type]}
          <span>{modalProps.title}</span>
        </div>
      }
      centered
      width={430}
      onOk={modalProps.onOk}
      onCancel={modalProps.onCancel}
      okText={modalProps.okText}
      cancelText={modalProps.cancelText}
      className={`custom-modal ${modalProps.type}`}
      okButtonProps={{
        loading,
        style: {
          minWidth: 100
        }
      }}
      cancelButtonProps={{
        style: {
          minWidth: 100
        }
      }}
      maskClosable={false}
      zIndex={10002}
    >
      <div className="mt-3 mb-5">{modalProps.content}</div>
    </Modal>
  )
}

export { showConfirm }
export default ModalConfirm
